<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import OmniSelect from "@/components/selects/OmniSelect.vue";
import { InvoiceStatusEnum } from "@/api/billing/dto/invoice";

const { t } = useI18n();

const model = defineModel<InvoiceStatusEnum | null>({ default: null });

const props = withDefaults(
  defineProps<{
    label?: string;
    clearable?: boolean;
  }>(),
  {
    label: "",
    clearable: false,
  },
);

const items = computed(() => {
  return Object.values(InvoiceStatusEnum).map((status) => ({ id: status, name: t(`billing.statuses.${status}`) }));
});
</script>

<template>
  <omni-select
    v-model="model"
    :clearable="props.clearable"
    :items="items"
    :label="props.label || t('billing.status')"
    data-qa="invoice-status-select"
  />
</template>
